import { render, staticRenderFns } from "./SpecialTable.vue?vue&type=template&id=4fbc63a9&scoped=true&lang=html"
import script from "./SpecialTable.vue?vue&type=script&lang=js"
export * from "./SpecialTable.vue?vue&type=script&lang=js"
import style0 from "./SpecialTable.vue?vue&type=style&index=0&id=4fbc63a9&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbc63a9",
  null
  
)

export default component.exports